import { render, staticRenderFns } from "./BiocharApplication.vue?vue&type=template&id=39c74377&scoped=true&"
import script from "./BiocharApplication.vue?vue&type=script&lang=js&"
export * from "./BiocharApplication.vue?vue&type=script&lang=js&"
import style0 from "./BiocharApplication.vue?vue&type=style&index=0&id=39c74377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c74377",
  null
  
)

export default component.exports